import React from 'react';
import { Battery, BatteryLow, BatteryMedium, BatteryFull } from 'lucide-react';
import './BatteryIcon.css';

interface BatteryIconProps {
  percentage: number;
  size?: number;
  color?: string;
}

export const BatteryIcon: React.FC<BatteryIconProps> = ({
  percentage,
  size = 20,
  color = '#34c05e',
}) => {
  const getBaseIcon = () => {
    if (percentage < 33) {
      return <Battery size={size} color={color} />;
    } else if (percentage < 66) {
      return <BatteryLow size={size} color={color} />;
    } else if (percentage < 100) {
      return <BatteryMedium size={size} color={color} />;
    } else {
      return <BatteryFull size={size} color={color} />;
    }
  };

  const getStatusIcon = () => {
    if (percentage < 33) {
      return <BatteryLow size={size} color={color} />;
    } else if (percentage < 66) {
      return <BatteryMedium size={size} color={color} />;
    } else if (percentage < 100) {
      return <BatteryFull size={size} color={color} />;
    } else {
      return null;
    }
  };

  const getBatteryStatusClass = () => {
    if (percentage < 33) return 'battery-empty';
    if (percentage < 66) return 'battery-low';
    if (percentage < 100) return 'battery-medium';
    return 'battery-full';
  };

  const isCharging = percentage < 100;

  return (
    <div className={`battery-icon-container ${getBatteryStatusClass()}`}>
      {getBaseIcon()}

      {isCharging ? (
        <div className='battery-status-overlay'>{getStatusIcon()}</div>
      ) : null}
    </div>
  );
};
